import React from 'react';
import PropTypes from 'prop-types';
import './PopupContent.css';

// eslint-disable-next-line no-unused-vars
export const PopupContent = ({ title, isNotification, content }) => (
  <div className="header__popup">
    <div className="header__popup-header">{title}</div>
    <div className="header__popup-content">
      {content.map((elem, index) => (
        <div
          key={String(index)}
          className="header__popup-element"
          onClick={elem.onClick}
        >
          {elem.value}
        </div>
      ))}
    </div>
  </div>
);

PopupContent.propTypes = {
  title: PropTypes.string,
  isNotification: PropTypes.bool,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};



// WEBPACK FOOTER //
// ./src/components/PopupContent/PopupContent.js